// Money formatting helpers.
// CLAUDE.md §11 & SKILL: money is always BIGINT cents, never float.
// Format only via Intl.NumberFormat with currency:'USD' — never compute on the client.

export const CENTS_PER_DOLLAR = 100;

export function centsToUsdString(
  cents: number | string | null | undefined,
  locale = 'en',
  options: Intl.NumberFormatOptions = {},
): string {
  if (cents === null || cents === undefined || cents === '') return '—';
  const n = typeof cents === 'string' ? Number(cents) : cents;
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: n % CENTS_PER_DOLLAR === 0 ? 0 : 2,
    minimumFractionDigits: 0,
    ...options,
  }).format(n / CENTS_PER_DOLLAR);
}

export function centsToUsdAmount(
  cents: number | null | undefined,
  locale = 'en',
): string {
  if (cents === null || cents === undefined) return '—';
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: cents % CENTS_PER_DOLLAR === 0 ? 0 : 2,
  }).format(cents / CENTS_PER_DOLLAR);
}

// User-input dollars → cents (string -> integer). Returns null if invalid.
export function dollarsInputToCents(input: string): number | null {
  const cleaned = input.trim().replace(/\s+/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const n = Number(cleaned);
  if (!Number.isFinite(n) || n < 0) return null;
  // Multiply by 100 carefully to avoid float artefacts.
  return Math.round(n * CENTS_PER_DOLLAR);
}

export function formatNumber(n: number, locale = 'en'): string {
  return new Intl.NumberFormat(locale).format(n);
}
